// If element is not animating, set the display to block

import { useEffect, useMemo, useState } from 'react';

import useMonitorVisibility from '@/hooks/use-monitor-visibility';

type Props = {
  wait?: boolean;
  delay?: number;
};
function useAnimateOnVisible(props?: Props) {
  const wait = props?.wait || false;
  const delay = props?.delay || 0;

  const [isMonitorVisible, setIsMonitorVisible] = useState(false);
  const [isReadyToShow, seIsReadyToShow] = useState(false);

  const [ref] = useMonitorVisibility({
    triggerOnce: () => {
      setIsMonitorVisible(true);
    },
  });

  useEffect(() => {
    if (!wait && isMonitorVisible && !isReadyToShow) {
      setTimeout(() => {
        seIsReadyToShow(true);
      }, delay);
    }
  }, [wait, isMonitorVisible, isReadyToShow, delay]);

  const animateClassName = useMemo(() => {
    return isReadyToShow ? 'animate-fadeIn' : 'opacity-0';
  }, [isReadyToShow]);

  return { ref, animateClassName };
}

export default useAnimateOnVisible;
